import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {IonNav, ModalController} from "@ionic/angular";
import {ModalPageAlias, NavigationService} from "../../service/navigation.service";

@Component({
  selector: 'app-modal-pages-container',
  templateUrl: './modal-pages-container.component.html',
  styleUrls: ['./modal-pages-container.component.scss'],
})
export class ModalPagesContainerComponent implements OnInit {

  @ViewChild('nav', {static: false}) nav?: IonNav;
  @Input() pageAlias: ModalPageAlias = 'login';

  constructor(private modalCtrl: ModalController,
              private navigationService: NavigationService) {
  }

  ngOnInit() {
  }

  async ngAfterViewInit() {
    await this._navigate();
  }

  close() {
    this.navigationService.closeModal();
    this.modalCtrl.dismiss();
  }


  private async _navigate() {
    await this.navigationService.setModalNavigationPages(this.nav, this.pageAlias);
  }


}
